<!-- Don't render the item if it has subitems but they're all filtered out due to permissions not being met -->
@if ((submenuItems | hasItems) === false || (submenuItemsToRender() | hasItems)) {
  @if ((submenuItemsToRender()?.length ?? 0) > 1) {
    <a class="menu-item" nz-submenu [nzTitle]="icon" nzMatchRouter [routerLink]="link">
      <ng-template #icon>
        <i [appIcon]="iconName" faStyle="thin" [style.font-size]="iconSizeOverride"></i>
      </ng-template>
      <p class="submenu-title">{{ title }}</p>
      <div>
        @for (submenuItem of submenuItemsToRender(); track $index) {
          @if (submenuItem.isHeader && (submenuItem.items | hasItems)) {
            <p class="submenu-title">{{ submenuItem.label }}</p>
            @for (item of submenuItem.items; track item.link) {
              <a nz-menu-item [routerLink]="item.link" nzMatchRouter>
                {{ item.label }}
              </a>
            }
          } @else {
            <a nz-menu-item [routerLink]="submenuItem.link" nzMatchRouter>
              <ng-container>{{ submenuItem.label }}</ng-container>
            </a>
          }
        }
      </div>
    </a>
  } @else {
    <a class="menu-item" [nz-tooltip]="title" nz-menu-item [routerLink]="link" nzMatchRouter>
      <i [appIcon]="iconName" [style.font-size]="iconSizeOverride" faStyle="thin"></i>
    </a>
  }
}
